import React, { useEffect } from "react";
import {
  X,
  MessageCircle,
  Mail,
  Phone,
  Clock,
  Sparkles,
  ArrowRight,
  Calendar,
} from "lucide-react";
import Logo from "../assets/logo.png";

export default function ContactModal({ isOpen, onClose }) {
  // 모달 열릴 때 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const contactMethods = [
    {
      icon: Mail,
      title: "이메일 문의",
      value: "ks2414e@naver.com",
      desc: "24시간 접수 가능",
      color: "from-blue-500 to-blue-600",
      href: "mailto:ks2414e@naver.com",
    },
    // {
    //   icon: Phone,
    //   title: "전화 상담",
    //   value: "02-1234-5678",
    //   desc: "평일 09:00 - 18:00",
    //   color: "from-green-500 to-emerald-600",
    //   href: "tel:02-1234-5678",
    // },
    // {
    //   icon: MessageCircle,
    //   title: "카카오톡 상담",
    //   value: "@elva_ai",
    //   desc: "실시간 상담 가능",
    //   color: "from-yellow-500 to-yellow-600",
    //   href: "http://pf.kakao.com/_elva_ai",
    // },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* 배경 오버레이 */}
      <div
        className="absolute inset-0 bg-black/80 backdrop-blur-md"
        onClick={onClose}
      />

      {/* 모달 컨테이너 */}
      <div className="relative w-full max-w-lg transform transition-all animate-modal-appear">
        <div className="relative bg-gray-900/95 backdrop-blur-xl border border-gray-800 rounded-3xl shadow-2xl overflow-hidden">
          {/* 배경 그라데이션 효과 */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-0 left-0 w-64 h-64 bg-blue-600 rounded-full filter blur-[100px]"></div>
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-purple-600 rounded-full filter blur-[100px]"></div>
          </div>

          {/* 닫기 버튼 */}
          <button
            onClick={onClose}
            className="absolute top-6 right-6 z-10 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all"
          >
            <X className="w-5 h-5 text-white" />
          </button>

          {/* 모달 콘텐츠 */}
          <div className="relative p-8 md:p-10">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl mb-6">
                <img
                  src={Logo}
                  alt="elva logo"
                  className="w-20 h-20 text-white"
                />
              </div>

              <h2 className="text-3xl font-bold text-white mb-4">
                계정 발급 안내
              </h2>

              <div className="bg-blue-500/10 border border-blue-500/30 rounded-2xl p-5 mb-6">
                <p className="text-gray-300 leading-relaxed">
                  현재 Elva는 온라인 가입이 제한됩니다.
                  <br />
                  <span className="text-white font-medium">
                    직접 상담을 통해 계정을 발급
                  </span>
                  해 드리고 있습니다.
                  <br />
                  불편을 드려 죄송하며, 번거로우시겠지만
                  <br />
                  아래 문의하기로 연락 부탁드립니다.
                </p>
              </div>

              <div className="inline-flex items-center gap-2 bg-green-500/20 text-green-400 px-4 py-2 rounded-full text-sm mb-8">
                <Clock className="w-4 h-4" />
                <span>평균 응답 시간: 3일 이내</span>
              </div>
            </div>

            {/* 연락 방법 */}
            <div className="space-y-3 mb-6">
              {contactMethods.map((method, index) => (
                <a key={index} href={method.href} className="group block">
                  <div className="relative bg-gray-800/50 hover:bg-gray-800/70 border border-gray-700 hover:border-gray-600 rounded-2xl p-4 transition-all duration-300">
                    <div className="flex items-center gap-4">
                      <div
                        className={`w-12 h-12 bg-gradient-to-br ${method.color} rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}
                      >
                        <method.icon className="w-6 h-6 text-white" />
                      </div>
                      <div className="flex-1 text-left">
                        <h3 className="text-white font-semibold mb-1">
                          {method.title}
                        </h3>
                        <p className="text-blue-400 text-sm">{method.value}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-gray-500 text-xs">{method.desc}</p>
                        <ArrowRight className="w-4 h-4 text-gray-600 group-hover:text-white group-hover:translate-x-1 transition-all ml-auto mt-1" />
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            {/* 추가 안내 */}
            <div className="bg-gradient-to-r from-purple-900/30 to-blue-900/30 rounded-2xl p-4 text-center">
              <div className="flex items-center justify-center gap-2 text-sm text-gray-300 mb-2">
                <Calendar className="w-4 h-4" />
                <span>상담 시 준비사항</span>
              </div>
              <p className="text-xs text-gray-400">
                회사명, 담당자명, 필요하신 서비스를 미리 준비해 주시면
                <br />
                더욱 빠른 상담이 가능합니다.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes modal-appear {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(10px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        .animate-modal-appear {
          animation: modal-appear 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}
